/* eslint-disable react/no-unescaped-entities */
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

import { useTranslation } from "react-i18next";

const About = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });
  const { t } = useTranslation();

  const Center = () => (
    <Box>
      <Box marginBottom={2}>
        <Typography variant="h4" color="text.primary" sx={{ fontWeight: 700 }}>
          Acro Beach Festival
        </Typography>
      </Box>
      <Box marginBottom={4}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Du jeudi 14 mai au 17 main 2026
        </Typography>
        <Typography component="p">Festival Gratuit d'Acro Yoga. Pendant 3 jours, venez assister aux et ateliers animés par des professeurs renommés venant des 4 coins de la planète ! Venez également assister au concert le samedi soir. Buvette et food truck sur place !</Typography>
      </Box>
      <Button
        variant="contained"
        color="primary"
        size="large"
        href="https://docs.google.com/forms/d/e/1FAIpQLSd1POas50nqOlurn4dUL-U1khXqKKwsMqk-kpuV37JxlgMzWQ/viewform"
        target="_blank"
      >
        M'inscrire gratuitement
      </Button>
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "background.level3",
        padding: { xs: 4, sm: 16 }, // Reduce padding for better centering
      }}
    >
      <Box
        sx={{
          maxWidth: 800, // Limit text width
          textAlign: "center", // Center text inside the box
        }}
      >
        <Center />
      </Box>
    </Box>
  );
};

export default About;
